import React from 'react';
import PropTypes from 'prop-types';

const windowRatioDefaultIcon = ({ className }) => (
  <svg
    version="1.1"
    x="0px"
    y="0px"
    width="63.94px"
    height="63.37px"
    viewBox="0 0 63.9 63.4"
    className={className}
  >
    <path fill="#787878" d="M54.8,53.4h-3.7V2H14.5v51.3h-3.7v4.3h3.7v4h36.7v-4h3.7V53.4z M19,7h28v46.3H19V7z" />
  </svg>
);
windowRatioDefaultIcon.propTypes = {
  className: PropTypes.string,
};
windowRatioDefaultIcon.defaultProps = {
  className: undefined,
};


export default windowRatioDefaultIcon;
